import axios from '../../http'

class DBUser {
  // 大B用户登录 info = {username:changshang, password:123456}
  login(info) {
    const url = '/api/db/login'
    return axios.post(url, info).then((res) => {
      return Promise.resolve(res.data)
    })
  };
  // 获取大B用户权限
  getPermission() {
    const url = `/api/authority/list`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // DB获取当前登录用户信息
  getDBInformation() {
    const url = '/api/db/get'
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  };
  // DB修改当前登录用户信息
  postDBModify(data) {
    const url = '/api/db/modify'
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  };
  // DB修改修改登录密码
  postDBChangePassword(data, surePassword, newPassword) {
    const url = '/api/db/login/modify'
    const datas = {
      data,
      surePassword,
      newPassword
    }
    return axios.post(url, datas).then((res) => {
      return Promise.resolve(res.data)
    })
  };
  // DB修改绑定手机
  getDBChangeTelephone(newTelephone, newTelephoneCode, data) {
    const url = '/api/db/modify/telephone'
    const datas = {
      newTelephone, newTelephoneCode, data
    }
    return axios.post(url, datas).then((res) => {
      return Promise.resolve(res.data)
    })
  };
  // DB退出登录
  getDBlogout() {
    const url = '/api/db/logout'
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  };
  // DB获取当前用户权限
  getDBAuthority() {
    const url = '/api/authority/list'
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
}

export default DBUser;
